import Best_edu from  "~images/sem/success-stories/best_edu.svg";
import Parents_choice from  "~images/sem/success-stories/parent_choice.svg";
import Best_elementary from  "~images/sem/success-stories/best_elementary.svg";
import i18n from "../../../../app/js/utils/i18n";

export const getData = () => [
    `${i18n.t("Personalized")} Learning Path for your Child`,
    "4000+ Curriculum aligned Skills",
    "Cancel Anytime"
]

export const awardImages = [
    Best_edu,
    Parents_choice,
    Best_elementary
]